<template>
  <div class="case--contact__wrapper">
    <ul class="case--contact__list">
      <li :style="{ color: background }">
        <span :style="{ color: color }">m:</span>
        <a href="mailto:hello@intervi.co">hello[at]intervi.co.</a>
      </li>
      <li :style="{ color: background }">
        <span :style="{ color: color }">p:</span>
        <a href="tel:+48510069993">+48 510 069 993</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CaseContact",
  data() {
    return {};
  },
  props: ["background", "color"],
};
</script>

<style scoped lang="scss">
.case--contact {
  &__wrapper {
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: 768px) {
      justify-content: flex-start;
    }
  }
  &__list {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    li {
      margin-left: 20px;
      @media screen and (max-width: 768px) {
        margin-left: 0;
      }
      span {
        font-size: 1.4rem;
        font-weight: 700;
      }
      a {
        color: #545454;
        font-size: 1.4rem;
        font-weight: 600;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/small-components/CaseContact.vue